module.exports = __webpack_public_path__ + "img/stock6.4f36202e.png";